import { render, staticRenderFns } from "./goodItem.vue?vue&type=template&id=4362e094"
import script from "./goodItem.vue?vue&type=script&lang=js"
export * from "./goodItem.vue?vue&type=script&lang=js"
import style0 from "./goodItem.vue?vue&type=style&index=0&id=4362e094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports